var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [_vm._m(0)]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [_vm._m(1)]
        : [_vm._m(2)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("특별자본금계좌")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " 회사설립 및 대베트남 직,간접투자를 위한 자본금을 예치하는 예금으로 입금 및 출금이 거래성격에 따라 제한되는 예금 "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("상품유형")]),
          _c("dd", [_vm._v("보통예금")]),
          _c("dt", [_vm._v("상품개요")]),
          _c("dd", [
            _vm._v(
              "회사설립 및 대베트남 직,간접투자를 위한 자본금을 예치하는 예금으로 입금 및 출금이 거래성격에 따라 제한되는 예금"
            )
          ]),
          _c("dt", [_vm._v("가입대상")]),
          _c("dd", [
            _vm._v("베트남 법령에 따라 설립되고 운영되는 베트남 기관, 개인")
          ]),
          _c("dt", [_vm._v("계약기간")]),
          _c("dd", [_vm._v("제한없음")]),
          _c("dt", [_vm._v("가입통화")]),
          _c("dd", [_vm._v("VND, USD")]),
          _c("dt", [_vm._v("가입금액")]),
          _c("dd", [_vm._v("제한없음")]),
          _c("dt", [_vm._v("금리 및 이율")]),
          _c("dd", [_vm._v("약정이율 연 0.00%")]),
          _c("dt", [_vm._v("수수료")]),
          _c("dd", [_vm._v("해당무")]),
          _c("dt", [_vm._v("가입방법")]),
          _c("dd", [_vm._v("영업점가입")]),
          _c("dt", [_vm._v("가입시 필요서류")]),
          _c("dd", [_vm._v("영업점 문의")]),
          _c("dt", [_vm._v("유의사항 및 기타")]),
          _c("dd", [
            _vm._v(
              "회사 자본금을 관리하는 계좌로 입금 및 출금이 거래 성격에 따라 제한됨"
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("Special capital account")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " This is a special account to deposit a capital for the establishment of the company or for direct and indirect investor, however, deposits and withdrawals of money might be restricted depending on the caracteristics of transaction. "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("Types")]),
          _c("dd", [_vm._v("Current Account")]),
          _c("dt", [_vm._v("About the products")]),
          _c("dd", [
            _vm._v(
              "This is a special account to deposit a capital for the establishment of the company or for direct and indirect investor, however, deposits and withdrawals of money might be restricted depending on the caracteristics of transaction."
            )
          ]),
          _c("dt", [_vm._v("Eligibilty")]),
          _c("dd", [
            _vm._v(
              "The Corporation that is established and operated in accordance with the laws and regulations of Vietnamese or individual"
            )
          ]),
          _c("dt", [_vm._v("Contract Terms")]),
          _c("dd", [_vm._v("No restrictions")]),
          _c("dt", [_vm._v("Available currency")]),
          _c("dd", [_vm._v("VND, USD")]),
          _c("dt", [_vm._v("Deposit amount")]),
          _c("dd", [_vm._v("No restrictions")]),
          _c("dt", [_vm._v("Loan Rate")]),
          _c("dd", [_vm._v("Agreed interest rate : 0.00% annually")]),
          _c("dt", [_vm._v("Fees")]),
          _c("dd", [_vm._v("N/A")]),
          _c("dt", [_vm._v("How to apply")]),
          _c("dd", [_vm._v("Apply at the branch")]),
          _c("dt", [_vm._v("Required documents for application")]),
          _c("dd", [_vm._v("Contact to our staff")]),
          _c("dt", [_vm._v("Notices and others")]),
          _c("dd", [
            _vm._v(
              "This is an account to manage the compnay funds and deposits, however, withdrawals of money might be restricted depending on the caracteristics of transaction"
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("Tiền gửi thanh toán doanh nghiệp")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("Hình thức sản phẩm")]),
          _c("dd", [_vm._v("Tiền gửi thông thường")]),
          _c("dt", [_vm._v("Giới thiệu sản phẩm")]),
          _c("dd", [
            _vm._v(
              "Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian"
            )
          ]),
          _c("dt", [_vm._v("Đối tượng gia nhập")]),
          _c("dd", [
            _vm._v(
              "Pháp nhân được thành lập và hoạt động theo pháp luật Việt Nam hoặc pháp luật nước ngoài"
            )
          ]),
          _c("dt", [_vm._v("Thời gian hợp đồng")]),
          _c("dd", [_vm._v("Không giới hạn")]),
          _c("dt", [_vm._v("Loại tiền tệ gia nhập")]),
          _c("dd", [_vm._v("VND, USD")]),
          _c("dt", [_vm._v("Số tiền gia nhập")]),
          _c("dd", [_vm._v("Không giới hạn")]),
          _c("dt", [_vm._v("Lãi suất")]),
          _c("dd", [
            _vm._v("Lãi suất cam kế t: USD 0.00% một năm, VND 0.10% một năm")
          ]),
          _c("dt", [_vm._v("Biểu phí")]),
          _c("dd", [_vm._v("Không có nội dung tương ứng")]),
          _c("dt", [_vm._v("Cách thức gia nhập")]),
          _c("dd", [_vm._v("Tham gia chi nhánh")]),
          _c("dt", [_vm._v("Giấy tờ cần thiết khi gia nhập")]),
          _c("dd", [
            _vm._v(
              "- Giấy phép thành lập hoặc hồ sơ pháp lý chứng minh việc thành lập hợp pháp."
            ),
            _c("br"),
            _vm._v(
              " - Tài liệu chứng minh người đại diện có thể ủy quyền pháp lý đại diện cho công ty."
            ),
            _c("br"),
            _vm._v(
              " - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người đại diện."
            ),
            _c("br"),
            _vm._v(
              " - Giấy ủy quyền của người đại diện ( trường hợp không phải là người đại diện gửi tiền )"
            ),
            _c("br"),
            _vm._v(
              " - Đăng ký chữ ký của người được ủy quyền, phạm vi quản lý tài khoản ( trường hợp không phải là người đại diện gửi tiền )"
            ),
            _c("br"),
            _vm._v(
              " - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người được ủy quyền ( trường hợp không phải là người đại diện gửi tiền )"
            )
          ]),
          _c("dt", [_vm._v("Lưu ý")]),
          _c("dd", [_vm._v("Số dư tối thiểu để duy trì tài khoản 10.00 USD")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }